import { dataSourceIdMap } from "features/data-source/data-source-id-map";
import { DataSourceName } from "features/data-source/data-source.types";

type DataSourceRegistryRecord = {
    id: string;
    name: DataSourceName;
};

export const dataSourceRegistry = {
    "activity-timeline/ca-popup": {
        id: dataSourceIdMap["ActivityTimeline_CAPopup"],
        name: "ActivityTimeline_CAPopup",
    },
    "agreements-type/device/line-chart": {
        id: dataSourceIdMap["DeviceDetailAgreementProfitability"],
        name: "DeviceDetailAgreementProfitability",
    },
    "agreements-type/line-chart": {
        id: dataSourceIdMap["CriticalAgreements_AgreementTypesLineChart"],
        name: "CriticalAgreements_AgreementTypesLineChart",
    },
    "connection-performance/farm-list": {
        id: dataSourceIdMap["ConnectionPerformance_FarmList"],
        name: "ConnectionPerformance_FarmList",
    },
    "connection-performance/kpi-text": {
        id: dataSourceIdMap["ConnectionPerformance_KPIText"],
        name: "ConnectionPerformance_KPIText",
    },
    "connection-performance/kpi-chart": {
        id: dataSourceIdMap["ConnectionPerformance_KPIChart"],
        name: "ConnectionPerformance_KPIChart",
    },
    "customer/fms/feeding/kpi-text": {
        id: dataSourceIdMap["CustomerDetail_FMS_FeedingOverview_KPIText"],
        name: "CustomerDetail_FMS_FeedingOverview_KPIText",
    },
    "customer/fms/feeding/kpi-chart": {
        id: dataSourceIdMap["CustomerDetail_FMS_FeedingOverview_KPIChart"],
        name: "CustomerDetail_FMS_FeedingOverview_KPIChart",
    },
    "customer/fms/installed-devices": {
        id: dataSourceIdMap["CustomerDetail_FMS_InstalledDevices"],
        name: "CustomerDetail_FMS_InstalledDevices",
    },
    "customer/kpi-text": {
        id: dataSourceIdMap["CustomerDetailKPIText"],
        name: "CustomerDetailKPIText",
    },
    "customer/kpi-chart": {
        id: dataSourceIdMap["CustomerDetailKPIChart"],
        name: "CustomerDetailKPIChart",
    },
    "device-compressor/low-air-pressure": {
        id: dataSourceIdMap["DeviceCompressorLowAirPressure"],
        name: "DeviceCompressorLowAirPressure",
    },
    "device-compressor/target": {
        id: dataSourceIdMap["DeviceCompressorTarget"],
        name: "DeviceCompressorTarget",
    },
    "fms/customer-list": {
        id: dataSourceIdMap["FMS_CustomerList"],
        name: "FMS_CustomerList",
    },
    "installed-devices": {
        id: dataSourceIdMap["InstalledDevices"],
        name: "InstalledDevices",
    },
    "search/device": {
        id: dataSourceIdMap["SearchDevice"],
        name: "SearchDevice",
    },
    "service-history-customer": {
        id: dataSourceIdMap["ServiceHistoryCustomer"],
        name: "ServiceHistoryCustomer",
    },
    "service-history-expanded-detail": {
        id: dataSourceIdMap["ServiceHistoryExpandedDetail"],
        name: "ServiceHistoryExpandedDetail",
    },
} satisfies Record<string, DataSourceRegistryRecord>;

type DataSourceRegistry = typeof dataSourceRegistry;
export type DataSourceRegistryPath = keyof DataSourceRegistry;

export const pathToNameMap: Record<DataSourceRegistryPath, DataSourceName> = Object.fromEntries(
    Object.entries(dataSourceRegistry).map(([path, value]) => [path, value.name])
) as Record<DataSourceRegistryPath, DataSourceName>;

export const nameToPathMap: Record<DataSourceName, DataSourceRegistryPath> = Object.fromEntries(
    Object.entries(dataSourceRegistry).map(([path, value]) => [value.name, path])
) as Record<DataSourceName, DataSourceRegistryPath>;
